import { Grid, Box, Button, CircularProgress, TextField } from "@mui/material";
import UploadFile from "../../UploadFile";
import { Controller, useFormContext } from "react-hook-form";
import DynamicFormHandler from "../../DynamicFormHandler";
import { TDetalheProcessoFormularioDyn } from "../../../types/api/bpm/detalhar-processo";
import TableMenuOptions from "../../TableMenuOptions";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function TarefaTipoSimples({
  handleClick,
  handleClickDevolver,
  isLoading,
  formularioDyn,
  extras,
}: TarefaTipoSimplesProps) {
  const {
    control,
    getValues,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useFormContext();

  //funções manipuladoras
  const handleConfirm = () => {
    const { observacoes, anexos } = getValues();

    const param: any = {};
    formularioDyn?.spec.forEach((item) => {
      const valor = getValues(item.name);
      param[item.name] = valor;
    });

    const jsonParam = JSON.stringify(param);

    handleClick(observacoes, anexos, jsonParam);
    reset();
  };

  //

  return (
    <Box display="flex" flexDirection="column">
      {formularioDyn &&
        formularioDyn.spec.map((item, index) => (
          <DynamicFormHandler {...{ extras }} key={index} spec={item} />
        ))}

      <Controller
        name="observacoes"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Observações"
            multiline
            minRows={2}
            variant="outlined"
          />
        )}
      />

      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 6 }}>
          <Controller
            name={"anexos"}
            control={control}
            render={({ field }) => (
              <UploadFile
                values={field.value}
                onChangeValues={(arquivos) => field.onChange(arquivos)}
                type="tarefa"
                btnActionsList={[
                  <Button
                    disabled={isLoading}
                    variant="contained"
                    onClick={handleSubmit(handleConfirm)}
                    style={{ width: 130 }}
                  >
                    {isLoading && (
                      <CircularProgress size={14} style={{ marginRight: 12 }} />
                    )}
                    Resolver
                  </Button>,
                ]}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 6 }} style={{ textAlign: "right" }}>
          <TableMenuOptions
            menuItems={[
              {
                label: "Devolver tarefa",
                icon: <RestartAltIcon color="primary" />,
                action: handleClickDevolver,
              },
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

interface TarefaTipoSimplesProps {
  isLoading: boolean;
  formularioDyn: TDetalheProcessoFormularioDyn | null;
  handleClick: (obs: string, anexos: File[], resposta: string) => void;
  handleClickDevolver: () => void;
  extras: any | null;
}
